import { z } from "zod";

export const AuditResourceSchema = z.enum([
  "draft",
  "record",
  "quote",
  "customer",
  "order",
  "document",
  "file",
  "item",
  "part",
  "sample",
  "report",
  "user",
  "member",
  "project",
  "task",
  "procedure",
  "request",
  "tool",
]);
export type AuditResource = z.infer<typeof AuditResourceSchema>;
export const AuditActionSchema = z.enum([
  "create",
  "read",
  "update",
  "delete",
  "execute",
  "open",
  "request",
]);
export const AuditRecordIdSchema = z
  .string()
  .max(128)
  .regex(
    /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}|[1-9][0-9]{0,14}|D-[0-9]{1,15}|(?:draft|record|quote|customer|order|doc|file|item|part|sample|report|user|usr|member|project|task|procedure|req)_[0-9a-f]{8,64})$/i,
  );
export const AuditActionNameSchema = z.enum([
  "submit",
  "confirm-review",
  "approve",
  "reject",
  "archive",
  "restore",
  "reanalyze",
  "upload",
  "download",
  "export",
  "import",
  "search",
  "send",
  "publish",
  "unpublish",
  "cancel",
  "customer",
]);
export const AuditTargetSchema = z.strictObject({
  action: AuditActionSchema,
  resourceType: AuditResourceSchema,
  recordId: AuditRecordIdSchema.optional(),
  actionName: AuditActionNameSchema.optional(),
});
export type AuditTarget = z.infer<typeof AuditTargetSchema>;
